/*
* Copyright (c) Nexign, JSC, 2019.
*/
/**
 *
 * @author Evgenij Tyan
 * @version 1.0.0
 * @since 1.0.0
 */
import { backgroundColorModal, backgroundColorWhite, borderColorNormal, ColorError } from './palette';

export const createInquiryFieldBg = backgroundColorModal;
export const createInquirySelectBg = backgroundColorWhite;

export const createInquiryError = ColorError;

export const createInquiryAttachBg = backgroundColorWhite;
export const createInquiryAttachBorder = borderColorNormal;
